<template>
    <div class="m-block m-moduleBlock u-bgWhite u-br u-px20 u-py30 u-mb15 u-border u-shadow u-w100">
        <div class="m-block__inner">
            <h3>{{ module.title }}</h3>
            <Progress :current="progress[0]" :total="progress[1]" v-if="progress.length >= 2 && progress[1] !== 0" />
            <div v-if="!module.completed" class="m-block__info u-mt10">
                <div class="a-tag" v-if="module.module_duration && !module.completed">
                    <i class='icon bx bx-time-five'></i> 
                    <span>{{ module.module_duration }}</span>
                </div>
                <div v-if="!module.completed" class="m-block__indicator u-fs12">   
                    <div v-if="moduleWaitingForFeedback && (moduleRating === 0 || moduleRating === 1)">
                        <div v-if="moduleRating === 0" class="a-tag -orange">{{ $t('module.failed') }}</div>
                        <div v-if="moduleRating === 1" class="a-tag -green">{{ $t('module.passed') }}</div>
                    </div>
                    <div v-else-if="moduleWaitingForFeedback && moduleRating === false">
                        <div class="a-tag -yellow">{{ $t('module.waitingForFeedback') }}</div>
                    </div>
                    <div v-else>
                        <div v-if="module.date_completed_by">
                            <span v-if="new Date(module.date_completed_by) > new Date(module.current_timestamp)">
                                {{ $t('module.toBeCompletedBy') }}: 
                                <span class="u-colorSecondary u-fw500">{{ formatDate(module.date_completed_by) }}</span>
                            </span>
                            <span v-else>
                                <div class="a-tag -red">{{ $t('module.completionDatePassed') }}</div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-block__cta u-mt20" v-if="new Date(module.date_completed_by) > new Date(module.current_timestamp)">
                <a 
                    :class="module.completed || (module.module_rating !== false) ? 'a-button -block -ghost' : 'a-button -block'" 
                    :href="module.completed || (module.module_rating !== false) ? `#/proofcards/${module.id}` : `#/modules/${module.id}`"
                >
                    {{ moduleButtonText }}
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, watchEffect } from 'vue';
import { calculateProgress, formatDate } from '../../utils/globalFunctions';
import { useI18n } from 'vue-i18n';

// Components
import Progress from '../atoms/Progress.vue';

const { t } = useI18n();

const props = defineProps({
    module: {
        type: Object,
        default: {},
    },
});

const progress = computed(() => {
    if (props.module.completed) {
        // Override progress to 100% when the module is completed
        return [1, 1];
    }
    const { completed, total } = calculateProgress(props.module.progress);
    return [completed, total];
});

const moduleRating = ref(false);
const moduleWaitingForFeedback = ref(false);
const moduleButtonText = ref(t('module.continueModule'));

watchEffect(() => {
    if (props.module.completed) {
        moduleWaitingForFeedback.value = false;
        moduleButtonText.value = t('proofCard.viewProofCard');
    } else if (progress.value[0] !== 0 && progress.value[1] !== 0) {
        if (progress.value[0] === progress.value[1]) {
            moduleButtonText.value = t('module.viewModule');
            if (props.module.module_rating !== false) {
                moduleRating.value = props.module.module_rating;
                moduleButtonText.value = t('proofCard.viewProofCard');
            }
            moduleWaitingForFeedback.value = true;
        } else {
            moduleWaitingForFeedback.value = false;
            moduleButtonText.value = t('module.continueModule');
        }
    } else {
        moduleWaitingForFeedback.value = false;
        if (props.module.module_rating !== false) {
            moduleWaitingForFeedback.value = true;
            moduleRating.value = props.module.module_rating;
            moduleButtonText.value = t('proofCard.viewProofCard');
        } else {
            moduleButtonText.value = t('module.startModule');
        }
    }
});
</script>